TrelloModel = require 'models/internal/trello-model'

module.exports = class BoardPlugin extends TrelloModel
  typeName: 'BoardPlugin'



// WEBPACK FOOTER //
// ./app/scripts/models/board-plugin.coffee